var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form-accordion",
        {
          attrs: {
            title: _vm.$t("common.formsSubTitle.gnrl"),
            isTitleUpperCase: false,
          },
        },
        [
          _c("div", {}, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("form-write-group-label-input", {
                  attrs: {
                    type: "number",
                    colInputSize: 0,
                    colLabelSize: 0,
                    inputClass: "justify-content-end",
                    horizontal: "",
                    isNotZero: "",
                    minValue: 0,
                    inputLabel: _vm.$t(
                      "administration.rtp_time_before_expiration"
                    ),
                  },
                  on: { blur: _vm.changeTimeBeforeExpSRTP },
                  model: {
                    value: _vm.settings.rtpsTimeBeforeExpiration,
                    callback: function ($$v) {
                      _vm.$set(_vm.settings, "rtpsTimeBeforeExpiration", $$v)
                    },
                    expression: "settings.rtpsTimeBeforeExpiration",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _vm.canSeeSRTP
                  ? _c("form-write-group-label-input", {
                      attrs: {
                        inputType: "number",
                        maxLength: 21,
                        colInputSize: 0,
                        colLabelSize: 0,
                        inputClass: "justify-content-end",
                        horizontal: "",
                        inputLabel: _vm.$t("settings.srtp_max_amnt_lng"),
                      },
                      on: { blur: _vm.changeMaxAmountSRTP },
                      model: {
                        value: _vm.settings.SRTPmaxAmount,
                        callback: function ($$v) {
                          _vm.$set(_vm.settings, "SRTPmaxAmount", $$v)
                        },
                        expression: "settings.SRTPmaxAmount",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _vm.canSeeHRTP
                  ? _c("form-write-group-label-input", {
                      attrs: {
                        inputType: "number",
                        maxLength: 21,
                        colInputSize: 0,
                        colLabelSize: 0,
                        inputClass: "justify-content-end",
                        horizontal: "",
                        inputLabel: _vm.$t("settings.hrtp_max_amnt_lng"),
                      },
                      on: { blur: _vm.changeMaxAmountHRTP },
                      model: {
                        value: _vm.settings.HRTPmaxAmount,
                        callback: function ($$v) {
                          _vm.$set(_vm.settings, "HRTPmaxAmount", $$v)
                        },
                        expression: "settings.HRTPmaxAmount",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }